var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-10 -pt-20 bg-gray-300 pt-8" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.dashboard, loading: _vm.loading } },
        [
          _vm.isAdmin
            ? _c(
                "div",
                {
                  staticClass:
                    "grid grid-cols-1 xl:grid-cols-2 xxl:grid-cols-2 gap-4 auto-rows-max",
                },
                [
                  _c("DashboardContractors", {
                    attrs: {
                      companyId: _vm.company.id,
                      currentUserId: _vm.currentUser.id,
                      currentUserRole: _vm.currentUser.role,
                      companyBusinessName: _vm.company.business_name,
                      contractors: _vm.contractors,
                      contractorsTotal: _vm.contractorsTotal,
                      newContractorsTotal: _vm.newContractorsTotal,
                      contractorsAvatar: _vm.contractorsAvatar,
                      currentUserManagerId: _vm.currentUserManagerId,
                      isAdmin: _vm.isAdmin,
                      currentUser: _vm.currentUser,
                    },
                  }),
                  _c("DashboardManagers", {
                    attrs: {
                      companyId: _vm.company.id,
                      currentUserId: _vm.currentUser.id,
                      companyBusinessName: _vm.company.business_name,
                      managers: _vm.managers,
                      contractors: _vm.contractors,
                      managersTotal: _vm.managersTotal,
                      requestsTotal: _vm.requestsTotal,
                      activeManagersCount: _vm.activeManagersCount,
                      accessAllowedManagersCount:
                        _vm.accessAllowedManagersCount,
                      subscriptionRequired:
                        _vm.currentUser.subscription_required,
                      isManager: _vm.isManager,
                      isAdmin: _vm.isAdmin,
                      company: _vm.company,
                      currentUser: _vm.currentUser,
                    },
                    on: { refresh: _vm.refreshPage },
                  }),
                  !_vm.isManager && !_vm.isAdmin
                    ? _c("DashboardManagerDB", {
                        attrs: {
                          companyId: _vm.company.id,
                          currentUserId: _vm.currentUser.id,
                          currentUserRole: _vm.currentUser.role,
                          companyBusinessName: _vm.company.business_name,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "div",
                {
                  staticClass:
                    "grid grid-cols-1 xl:grid-cols-4 xxl:grid-cols-4 gap-4 auto-rows-max mt-4",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-span-12" },
                    [
                      _c("DashboardProjects", {
                        attrs: {
                          companyId: _vm.company.id,
                          currentUser: _vm.currentUser,
                          isManager: _vm.isManager,
                          isAdmin: _vm.isAdmin,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.isManager
            ? _c(
                "div",
                {
                  staticClass:
                    "grid grid-cols-1 xl:grid-cols-4 xxl:grid-cols-4 gap-4 auto-rows-max",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-span-12" },
                    [
                      _c("DashboardProjects", {
                        attrs: {
                          companyId: _vm.company.id,
                          currentUser: _vm.currentUser,
                          isManager: _vm.isManager,
                          isAdmin: _vm.isAdmin,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.isManager
            ? _c(
                "div",
                {
                  staticClass:
                    "grid grid-cols-1 xl:grid-cols-2 xxl:grid-cols-2 gap-4 auto-rows-max mt-4",
                },
                [
                  _c("DashboardManagers", {
                    attrs: {
                      companyId: _vm.company.id,
                      currentUserId: _vm.currentUser.id,
                      companyBusinessName: _vm.company.business_name,
                      managers: _vm.managers,
                      contractors: _vm.contractors,
                      managersTotal: _vm.managersTotal,
                      requestsTotal: _vm.requestsTotal,
                      activeManagersCount: _vm.activeManagersCount,
                      accessAllowedManagersCount:
                        _vm.accessAllowedManagersCount,
                      subscriptionRequired:
                        _vm.currentUser.subscription_required,
                      isManager: _vm.isManager,
                      isAdmin: _vm.isAdmin,
                      company: _vm.company,
                      currentUser: _vm.currentUser,
                    },
                  }),
                  _c("DashboardContractorsManagerView", {
                    attrs: {
                      companyId: _vm.company.id,
                      currentUserId: _vm.currentUser.id,
                      currentUserRole: _vm.currentUser.role,
                      companyBusinessName: _vm.company.business_name,
                      contractors: _vm.contractors,
                      contractorsTotal: _vm.contractorsTotal,
                      newContractorsTotal: _vm.newContractorsTotal,
                      contractorsAvatar: _vm.contractorsAvatar,
                      currentUserManagerId: _vm.currentUserManagerId,
                      isAdmin: _vm.isAdmin,
                      currentUser: _vm.currentUser,
                      requestsTotal: _vm.requestsTotal,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "grid grid-cols-1 xl:grid-cols-2 xxl:grid-cols-2 gap-4 auto-rows-max mt-4",
            },
            [
              _c("DashboardGroups", {
                attrs: {
                  companyId: _vm.company.id,
                  currentUser: _vm.currentUser,
                },
              }),
              _c("DashboardDocuments", {
                attrs: {
                  companyId: _vm.company.id,
                  currentUserId: _vm.currentUser.id,
                  isAdmin: _vm.isAdmin,
                  currentUser: _vm.currentUser,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }